<template>
  <main>
    <AppTitle v-text="'рейтинг'"/>
    <Preloader v-if="loading"/>
    <AppRating 
      v-else
      :user="user"
      :slide="slide"
      @next="nextSlide"
      @prev="prevSlide"
    />
  </main>
</template>


<script>
import AppRating from '@/components/game/AppRating';
import AppTitle from '@/components/game/ui/AppTitle';
import Preloader from '@/components/game/Preloader';

import { mapGetters } from 'vuex';
import _ from 'lodash';

export default {
  name: 'Game_RatingsView',

  components: {
    Preloader,
    AppRating,
    AppTitle,
  },

  data: () => ({
    loading: true,
    slideId: 'all',
    ratingBy: {
      all: { title: 'Всё время' },
      day: { title: 'Сегодня' },
      stock: { 
        title: 'Розыгрыш',
        data: [{ title: 'Следующий розыгрыш состоится в ближайшее время. Следите за объявлениями в игре!' }]
      },
      lastStock: { title: 'Прошлый розыгрыш' },
    },
  }),

  computed: {
    ...mapGetters([
      'ratings',
      'lastEndedStock',
      'selectedStock',
      'usersList',
      'usersListWithUser',
      'prizesList',
      'axiosOptions',
      'orientation',
      'token',
      'user',
    ]),
    slide: ths => ths.ratingBy[ths.slideId],
    slideKeys: ths => Object.keys(ths.ratingBy),
    slideIndex: ths => ths.slideKeys.indexOf(ths.slideId),

    user_stock_key: ths => `${ths.user._id}_${ths.selectedStock._id}`,
    user_lastStock_key: ths => `${ths.user._id}_${ths.lastEndedStock._id}`,
  },

  watch: {
    'user._id': {
      immediate: true,
      async handler(userId) {
        if (!this.loading || !userId) return;
        try {
          await Promise.all([
            this.fetchRatingAll(),
            this.fetchRatingDay(),
          ]);
        } catch(err) {
          console.error(err);
        } finally {
          this.loading = false;
        };
      },
    },
    user_stock_key: {
      immediate: true,
      handler() {
        if (!this.user._id) return;
        if (!this.selectedStock._id) return;
        if (this.ratingBy.stock.data) return;
        this.fetchRatingStock();
      },
    },
    user_lastStock_key: {
      immediate: true,
      handler() {
        if (!this.user._id) return;
        if (!this.lastEndedStock._id) return;
        if (this.ratingBy.lastStock.data) return;
        this.fetchRatingLastStock();
      },
    },
  },

  mounted() {
    this.$store.dispatch('checkGameDuration');
  },

  methods: {
    nextSlide() {
      const newIndex = (this.slideIndex + 1) % this.slideKeys.length;
      this.slideId = this.slideKeys[newIndex];
    },
    prevSlide() {
      const newIndex = (this.slideIndex - 1 + this.slideKeys.length) % this.slideKeys.length;
      this.slideId = this.slideKeys[newIndex];
    },

    fetchRatingAll() {
      return new Promise(async (resolve, reject) => {
        try {
          const url = new URL('/api/rating/all/top', location.origin);
          url.searchParams.set('userId', this.user._id);
          const response = await fetch(url.toString(), this.axiosOptions);
          const users = await response.json();
          if (!Array.isArray(users)) throw new Error('invalid response');
          this.$set(this.ratingBy.all, 'data', [{ users }]);
          resolve(true);
        } catch(err) {
          console.error(err);
          reject(err);
        };
      });
    },

    fetchRatingDay() {
      return new Promise(async (resolve, reject) => {
        try {
          const url = new URL('/api/rating/day/top', location.origin);
          url.searchParams.set('userId', this.user._id);
          const response = await fetch(url.toString(), this.axiosOptions);
          const users = await response.json();
          if (!Array.isArray(users)) throw new Error('invalid response');
          this.$set(this.ratingBy.day, 'data', [{ users }]);
          resolve(true);
        } catch(err) {
          console.error(err);
          reject(err);
        };
      });
    },

    fetchRatingStock() {
      return new Promise(async (resolve, reject) => {
        try {
          const url = new URL('/api/rating/stock/top', location.origin);
          url.searchParams.set('stockId', this.selectedStock._id);
          url.searchParams.set('userId', this.user._id);
          const response = await fetch(url.toString(), this.axiosOptions);
          const users = await response.json();
          if (!Array.isArray(users)) throw new Error('invalid response');
          this.$set(this.ratingBy.stock, 'data', [{ users }]);
          resolve(true);
        } catch(err) {
          console.error(err);
          reject(err);
        };
      });
    },

    fetchRatingLastStock() {
      return new Promise(async (resolve, reject) => {
        try {
          const url = new URL('/api/rating/stock/top', location.origin);
          url.searchParams.set('stockId', this.lastEndedStock._id);
          url.searchParams.set('userId', this.user._id);
          const response = await fetch(url.toString(), this.axiosOptions);
          const users = await response.json();
          if (!Array.isArray(users)) throw new Error('invalid response');

          const prizesList = _.keys(this.lastEndedStock.prizes);
          const data = _.reduce(_.groupBy(users, 'prize'), (acc, users, prizeId) => {
            let priorityIndex = _.indexOf(prizesList, prizeId);
            if (priorityIndex === -1) priorityIndex = prizesList.length;
            const title = _.get(this.prizesList[prizeId], 'name', 'Без приза');
            _.set(acc, priorityIndex, { title, users });
            return acc;
          }, _.times(prizesList.length + 1));

          this.$set(this.ratingBy.lastStock, 'data', _.filter(data, 'users.length'));
          resolve(true);
        } catch(err) {
          console.error(err);
          reject(err);
        };
      });
    },
  },
};
</script>


<style lang="scss" scoped>
main {
  & > h1 {
    margin: 0 auto;
    font-size: 50px
  }
}
</style>
